<template>
    <div class="content">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询条件</span>
            </div>
            <div class="box-cont">
                <el-form :model="queryParams" ref="queryForm" :inline="true">
                    <el-form-item label="单位名称:" prop="dwmc">
                        <el-input
                        v-model="queryParams.dwmc"
                        placeholder="请输入单位名称"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item>
                    <el-form-item label="专业类别:" prop="zylb">
                        <el-select v-model="queryParams.zylb" clearable placeholder="请选择专业类别" size="small">
                            <el-option
                                v-for="dict in zylbOptions"
                                :key="dict.ID"
                                :label="dict.mc"
                                :value="dict.ID"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="文书名称:" prop="wsmc">
                        <el-input
                        v-model="queryParams.wsmc"
                        placeholder="请输入文书名称"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item> -->
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button>
                        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询结果</span>
                <p>单位数量:{{total}}</p>
            </div>
            <div class="box-cont">
                <el-table v-loading="loading" :data="ajslList">
                    <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="80">
                        <template slot-scope="scope">
                            <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="编号" align="center" prop="zlsh" width="140" />
                    <el-table-column label="检查日期" align="center"  width="180">
                        <template slot-scope="scope">
                            <span v-if="scope.row.jiancha_rq">{{getDate(scope.row.jiancha_rq,'yyyy-MM-dd hh:mm:ss')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="陪同人" align="center" prop="bl_xwr" width="100" />
                    <el-table-column label="监督对象名称" prop="dwmc" />
                    <el-table-column label="专业类别" align="center" prop="zylb1" width="120" />
                    <el-table-column label="经办人" align="center" prop="host_man" width="100"  />
                    <el-table-column label="协办人" align="center" prop="cooperate_man" width="100" />
                    <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="120" >
                        <template slot-scope="scope">
                            <el-button
                            size="small"
                            type="text"
                            @click="handleSelect(scope.row)"
                        >查看文书</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-part" style="padding:20px 20px 50px;">
                    <el-pagination  v-if="pageshow"
                        background
                        @size-change='handleSizeChange'
                        @current-change='handleCurrentChange'
                        :current-page="queryParams.page"
                        :page-sizes="[10,20,30,40]"
                        :page-size="queryParams.limit"
                        layout="total, prev, pager, next, jumper"
                        :total="total" style=" float:right;">
                    </el-pagination>
                </div>
            </div>
        </el-card>
        <el-dialog title="文书信息" :visible.sync="open" width="600px" append-to-body :close-on-click-modal="false">
            <el-table v-loading="loading2" :data="wsList">
                <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="80">
                    <template slot-scope="scope">
                        <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="文书名称" prop="title" />
                <el-table-column label="文书状态" align="center" prop="status" />
                <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                    <template slot-scope="scope">
                        <el-button
                        size="small"
                        type="text"
                        @click="handleYulan(scope.row)"
                    >预览</el-button>
                    <el-button
                        size="small"
                        type="text"
                        @click="handleDayin(scope.row)"
                    >打印</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            cmid:'',
            queryParams:{
                dwmc:'',
                zylb:'',
                page:1,
                limit:10,
            },
            total:0,
            ajslList:[],
            zylbOptions:[],
            checkList:[],
            open:false,
            pageshow:true,
            loading2:false,
            wsList:[],
            baseUrl:''
        }
    },
    components: {
    },
    computed: {
    },
    created() {
    },
    async mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.cmid = user.c_mid
        axios({
            method: 'post',
            url: `https://xxswj.hzxhykj.com:9086/login/getZylb`,
            data:{
                 "cfxt":""
            },
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.zylbOptions = res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })
        this.getList()
    },
    methods: {
        getList(){
            this.ajslList = []
            this.total = 0
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/login/getxczfws`,
                data:{
                    zylb:this.queryParams.zylb,
                    dwmc:this.queryParams.dwmc,
                    cmid:this.cmid,
                    limit:this.queryParams.limit,
                    page:this.queryParams.page
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                this.loading = false
                if(res.data.code == 0 && res.data.data){
                    this.ajslList = res.data.data.list
                    this.total = res.data.data.total || 0
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(error => {
                this.loading = false
                this.$message.error(error);
            })
        },
        zylbFormat(row, column) {
            return this.zylbLabel(this.zylbOptions, row.zylb)
        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleAdd(){},
        async handleSelect(row){
            this.open = true
            this.loading2 = false
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getxczfwsxq&id=${row.id}`)
            if(data.data){
                this.wsList = data.data
            }
        },
        resetQuery(){
            this.queryParams = {
                dwmc:'',
                zylb:'',
                page:1,
                limit:10,
            }
            this.getList()
        },
        handleYulan(row){
            let url = 'https://dapc1.scqwszfd.cn:8123'+row.url+'?time='+new Date().getTime()
            window.open(url,'_blank')
        },
        handleDayin(row){
            let url = 'https://dapc1.scqwszfd.cn:8123'+row.url+'?time='+new Date().getTime()
            window.open(url,'_blank')
        },
    }
}
</script>


<style scoped>
</style>